'use client';

import { c as _c } from "react/compiler-runtime";
import { useMediaState } from '@7f-ui/hooks/use-media-state';
import type { PaxParams } from '@feat/feat-url-state/pax';
import { serializeUrlState } from '@feat/feat-url-state/schema';
import { useUrlState } from '@feat/feat-url-state/use-url-state';
import { useRouter } from 'next/navigation';
import { useCallback, useTransition } from 'react';
import { useAppAccommodationBookingBoxContext } from '../_components/app-accommodation-booking-box-provider';
import type { AccommodationConfig } from '../_lib/accommodation-config';
export function useAppAccommodationConfigModal() {
  const $ = _c(22);
  const router = useRouter();
  const isMobile = useMediaState("mobile");
  const {
    updateUrlState
  } = useUrlState();
  const [isDateSubmitPending, startDateSubmitTransition] = useTransition();
  const {
    setShowRoomRatesModal,
    navigateOnDateSubmit,
    setActiveContent,
    activeContent
  } = useAppAccommodationBookingBoxContext();
  let t0;
  if ($[0] !== isMobile || $[1] !== setActiveContent || $[2] !== updateUrlState) {
    t0 = values => {
      updateUrlState({
        ...values
      });
      if (isMobile) {
        setActiveContent("Date");
        return;
      }
      setActiveContent(undefined);
    };
    $[0] = isMobile;
    $[1] = setActiveContent;
    $[2] = updateUrlState;
    $[3] = t0;
  } else {
    t0 = $[3];
  }
  const handlePaxSubmit = t0;
  let t1;
  if ($[4] !== navigateOnDateSubmit || $[5] !== router || $[6] !== setActiveContent || $[7] !== setShowRoomRatesModal || $[8] !== updateUrlState) {
    t1 = (config, isSingleRoom, roomsUrl) => {
      updateUrlState({
        from: config.from,
        to: config.to
      });
      setActiveContent(undefined);
      if (isSingleRoom) {
        setShowRoomRatesModal(true);
        return;
      }
      if (!navigateOnDateSubmit) {
        return;
      }
      const search = serializeUrlState(config);
      startDateSubmitTransition(() => {
        router.push(search ? `${roomsUrl}?${search}` : roomsUrl);
      });
    };
    $[4] = navigateOnDateSubmit;
    $[5] = router;
    $[6] = setActiveContent;
    $[7] = setShowRoomRatesModal;
    $[8] = updateUrlState;
    $[9] = t1;
  } else {
    t1 = $[9];
  }
  const handleDateSubmit = t1;
  let t2;
  if ($[10] !== setActiveContent) {
    t2 = () => setActiveContent("Pax");
    $[10] = setActiveContent;
    $[11] = t2;
  } else {
    t2 = $[11];
  }
  const handleBackClick = t2;
  let t3;
  if ($[12] !== setActiveContent) {
    t3 = () => setActiveContent(undefined);
    $[12] = setActiveContent;
    $[13] = t3;
  } else {
    t3 = $[13];
  }
  const handleClose = t3;
  const t4 = isMobile ? handleBackClick : undefined;
  let t5;
  if ($[14] !== activeContent || $[15] !== handleClose || $[16] !== handleDateSubmit || $[17] !== handlePaxSubmit || $[18] !== isDateSubmitPending || $[19] !== setActiveContent || $[20] !== t4) {
    t5 = {
      activeContent,
      setActiveContent,
      handlePaxSubmit,
      handleDateSubmit,
      handleBackClick: t4,
      handleClose,
      isDateSubmitPending
    };
    $[14] = activeContent;
    $[15] = handleClose;
    $[16] = handleDateSubmit;
    $[17] = handlePaxSubmit;
    $[18] = isDateSubmitPending;
    $[19] = setActiveContent;
    $[20] = t4;
    $[21] = t5;
  } else {
    t5 = $[21];
  }
  return t5;
}